import Config from 'app/config';

const embedBaseURL = Config.get('EMBED_HOST') || 'https://embed.acast.com/';

export default ({ width, height, showSlug, episodeSlug }) => {
  return `<iframe width="${width}" height="${height}" src="${embedBaseURL}${showSlug}${
    episodeSlug ? `/${episodeSlug}` : ''
  }" scrolling="no" frameborder="0" style="border:none;overflow:hidden;"></iframe>`;
};
